import React from "react";
import { defineBlock } from "@smartfire/gutenberg-react";
import style from "./block.module.scss";
import { ReactComponent as Facebook } from "../assets/facebook.svg";
import { ReactComponent as Twitter } from "../assets/twitter.svg";
import { ReactComponent as Instagram } from "../assets/instagram.svg";
import { useTranslation } from "react-i18next";
import Logo from "../assets/logo.svg";
import Obfuscate from "react-obfuscate";

function Block({ custom_settings, menuBottom }) {
  const { t } = useTranslation();
  return (
    <div className={style.block}>
      <div className={style.top}>
        <div className={style.logo}>
          <a href="/">
            <img src={Logo} alt="Logo" />
          </a>
        </div>
      </div>
      <div className={style.middle}>
        <div className={style.socialBlock}>
          <h4>{t("Suivez-nous")}</h4>
          <div className={style.social}>
            <div className={style.link}>
              <a
                href={custom_settings["facebook"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook />
              </a>
            </div>
            <div className={style.link}>
              <a
                href={custom_settings["twitter"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter />
              </a>
            </div>
            <div className={style.link}>
              <a
                href={custom_settings["instagram"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram />
              </a>
            </div>
          </div>
          <div
            className={style.menu}
            dangerouslySetInnerHTML={{ __html: menuBottom }}
          />
        </div>
      </div>
      <div className={style.bottom}>
        {t(
          "L’abus d’alcool est dangereux pour la santé. À consommer avec modération."
        )}
        <br />
        Crus Bourgeois du Médoc - 17 rue Despax 33200 Bordeaux - 05 56 79 04 11
        - <Obfuscate email="alliance@crus-bourgeois.com" />
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  setup: {
    title: "Footer",
  },
});
